import { render } from "./BaseDropzone.vue?vue&type=template&id=2d4f8d9c&scoped=true"
import script from "./BaseDropzone.vue?vue&type=script&lang=js"
export * from "./BaseDropzone.vue?vue&type=script&lang=js"

import "./BaseDropzone.vue?vue&type=style&index=0&id=2d4f8d9c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-2d4f8d9c"

export default script